const HighlightedText = ({ text, highlights = [], highlightColor = '#2979ff' }) => {
    const parts = text.split(new RegExp(`(${highlights.join('|')})`, 'g'));
    
    return parts.map((part, i) => (
      highlights.includes(part) ? (
        <span key={i} style={{ color: highlightColor }}>
          {part}
        </span>
      ) : (
        part
      )
    ));
  };

  export default HighlightedText;